import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '../Layout';
import '../../../global.css';
import { useNavigate, Link } from 'react-router-dom';
import Back from '../../../components/common/Back';
import nextSvg from '../../../images/next.svg';
import api from '../../../api';
import {deleteCookie} from '../../../utils';
import { logout } from '../../../redux/slices/protectSlice';

const Configuration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/logout`, {}, {});
      if (response.data.status === 'Success') {
        deleteCookie('accessToken');
        dispatch(logout());
        localStorage.removeItem('token');
        navigate('/admin/login');
      } else {
      }
    } catch (error) {
    }
  };

  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Configurations</h1>
            <div className="ms-auto">
               <Back />
            </div>
          </header>
          <div className="main-content flex justify-between flex-col-rev-mob">
            <div className="phases-container" style={{minHeight:'unset'}}>
              <div className="tab-content-info" id="tab4">
                <div className="tab-content-info-title">
                  <h2>My Account</h2>
                </div>
                <ul>
                  <li>
                    <Link to="/admin/profile">
                      <img
                        src={nextSvg}
                        alt="Profile"
                      />
                      <span>Update Personal Information & Goals</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/change-password">
                      <img
                        src={nextSvg}
                        alt="Change Password"
                      />
                      <span>Change Password</span>
                    </Link>
                  </li>

                   {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                   <>
                   <li>
                    <Link to="/admin/privacy-policy">
                      <img
                        src={nextSvg}
                        alt="Privacy Policy"
                      />
                      <span>Privacy Policy</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/terms-and-conditions">
                      <img
                        src={nextSvg}
                        alt="T&C"
                      />
                      <span>Terms and Conditions</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/payments-list">
                      <img
                        src={nextSvg}
                        alt="Payments"
                      />
                      <span>Payments List</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/admin/enquiries-list">
                      <img
                        src={nextSvg}
                        alt="Enquiries"
                      />
                      <span>Enquiries List</span>
                    </Link>
                  </li>
                  </>
                  )}

                  <li>
                    <Link onClick={handleLogout}>
                      <img
                        src={nextSvg}
                        alt="Logout"
                      />
                      <span>Logout</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Configuration;